function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.474,20.724l-5.365-5.365a.525.525,0,0,0-.376-.155h-.583a9.191,9.191,0,1,0-.946.946v.583a.543.543,0,0,0,.155.376l5.365,5.365a.531.531,0,0,0,.751,0l1-1A.531.531,0,0,0,22.474,20.724ZM9.193,16.264a7.071,7.071,0,1,1,7.071-7.071A7.069,7.069,0,0,1,9.193,16.264Z"
});

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.63,
    height: 22.63,
    viewBox: "0 0 22.63 22.63"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Search.8da3a1f7.svg";
export { SvgSearch as ReactComponent };